/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const formTemplatePages = sqliteTable('form_template_pages', {
  id: text('id').primaryKey().notNull(),
  form_definition_id: text('form_definition_id'),
  page_number: integer('page_number'),
  image_url: text('image_url'),
  image_width: integer('image_width'),
  image_height: integer('image_height'),
  label: text('label'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
